import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="108"
    viewBox="0 0 108 108"
    width="108"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <filter
      id="a"
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
      height="108"
      width="108"
      x="0"
      y="0"
    >
      <feFlood floodOpacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset dy="2" />
      <feGaussianBlur stdDeviation="5" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
      <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
      <feBlend in="SourceGraphic" in2="effect1_dropShadow" mode="normal" result="shape" />
    </filter>
    <g filter="url(#a)">
      <rect height="88" rx="16" width="88" x="10" y="8" />
      <g strokeWidth="2">
        <g strokeLinecap="round">
          <path d="m36 68 7.5858-7.5858c.781-.781.781-2.0474 0-2.8284l-7.5858-7.5858" />
          <path d="m60 50h-9" />
          <path d="m67 56h-16" />
          <path d="m56 62h-5" />
          <path d="m55 68h-4" />
          <path d="m73 50h-9" />
          <path d="m73 41h-38" />
          <path d="m37 36h-1" />
          <path d="m41 36h-1" />
          <path d="m45 36h-1" />
          <path d="m73 56h-2" />
          <path d="m73 62h-13" />
          <path d="m73 68h-6" />
          <path d="m63 68h-4" />
        </g>
        <rect fill="none" height="60" rx="16" width="60" x="24" y="24" />
      </g>
    </g>
  </svg>
);
